module.exports = __webpack_public_path__ + "img/fjl-b10h.prt.88e6035f.jpg";